/**
 * 설치기사 화면 ↔ 주소. `/`(설치) · `/as` · `/daypay` · `/orders/{id}`(상세).
 * 상세에서 돌아갈 탭은 주소가 아니라 history state 에 둔다 — 같은 상세를 A/S 탭에서
 * 열었는지 설치 탭에서 열었는지는 주소로 구분할 가치가 없다.
 */

export type Tab = 'orders' | 'as' | 'daypay';
export type Route = { name: Tab } | { name: 'order'; id: number; from: Tab };

export const TAB_PATH: Record<Tab, string> = { orders: '/', as: '/as', daypay: '/daypay' };

export function routeToPath(route: Route): string {
  return route.name === 'order' ? `/orders/${route.id}` : TAB_PATH[route.name];
}

function isTab(value: unknown): value is Tab {
  return value === 'orders' || value === 'as' || value === 'daypay';
}

/** 모르는 경로는 설치 목록. state.from 이 없으면(딥링크) 설치 탭으로 돌아간다. */
export function routeFromPath(path: string, state: unknown): Route {
  const clean = path.length > 1 ? path.replace(/\/+$/, '') : path;
  const detail = /^\/orders\/(\d+)$/.exec(clean);
  if (detail) {
    const from = (state as { from?: unknown } | null)?.from;
    return { name: 'order', id: Number(detail[1]), from: isTab(from) ? from : 'orders' };
  }
  const tab = (Object.keys(TAB_PATH) as Tab[]).find((t) => TAB_PATH[t] === clean);
  return { name: tab ?? 'orders' };
}
